var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReaders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.5H19V11.5H17.5V18.25H5.5V6.25L12.25 6.24933V4.75H9.25V1.75H7.75V4.75H5.5C5.1023 4.7504 4.721 4.90856 4.43978 5.18978C4.15856 5.471 4.0004 5.8523 4 6.25V8.5H1V10H4V14.5H1V16H4V18.25C4.00046 18.6477 4.15864 19.0289 4.43984 19.3102C4.72105 19.5914 5.10232 19.7495 5.5 19.75H7.75V22.75H9.25V19.75H13.75V22.75H15.25V19.75H17.5C17.8977 19.7495 18.2789 19.5913 18.5601 19.3101C18.8413 19.0289 18.9995 18.6477 19 18.25V16H22V14.5Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 16H7.75V8.5H15.25V16ZM9.25 14.5H13.75V10H9.25V14.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 10H21.25C21.2477 8.01159 20.4568 6.10528 19.0507 4.69926C17.6447 3.29324 15.7384 2.50232 13.75 2.5V1C16.1362 1.0026 18.4238 1.95165 20.1111 3.63891C21.7984 5.32618 22.7474 7.61385 22.75 10Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H17.5C17.4988 9.0058 17.1034 8.05265 16.4004 7.34964C15.6973 6.64664 14.7442 6.25117 13.75 6.25V4.75C15.1419 4.75169 16.4762 5.30535 17.4604 6.28955C18.4446 7.27375 18.9983 8.60813 19 10Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReaders);
export default __webpack_public_path__ + "static/media/ic-readers.10f7eeb69845b36132510016e4dd632f.svg";
export { ForwardRef as ReactComponent };